import { c as _c } from "react/compiler-runtime";
import ProfileName, { ProfileNameType } from "@/components/profile-activity/ProfileName";
import UserTableHeaderWrapper from "@/components/user/utils/UserTableHeaderWrapper";
import { ProfileRatersTableType } from "@/types/enums";
export default function ProfileRatersTableWrapperHeader(t0) {
  const $ = _c(13);
  const {
    type
  } = t0;
  let t1;
  if ($[0] !== type) {
    t1 = type === ProfileRatersTableType.CIC_RECEIVED && <div>Who's NIC-Rating <ProfileName type={ProfileNameType.DEFAULT} /></div>;
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== type) {
    t2 = type === ProfileRatersTableType.CIC_GIVEN && <div>Who's <ProfileName type={ProfileNameType.DEFAULT} /> NIC-Rating</div>;
    $[2] = type;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== type) {
    t3 = type === ProfileRatersTableType.REP_RECEIVED && <div>Who's Repping <ProfileName type={ProfileNameType.DEFAULT} /></div>;
    $[4] = type;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== type) {
    t4 = type === ProfileRatersTableType.REP_GIVEN && <div>Who's <ProfileName type={ProfileNameType.DEFAULT} /> Repping</div>;
    $[6] = type;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <UserTableHeaderWrapper>{t1}{t2}{t3}{t4}</UserTableHeaderWrapper>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}